import React, { useRef } from "react";
import { TooltipContainer } from "@outplayed/tooltips";
import DefaultSelect from "components/DefaultSelect";
import { useTranslation } from "react-i18next";
import { classTypeIdx } from "../../../hooks/path-hooks";

const Class = (props) => {
  const tooltipRef = useRef();
  const { t } = useTranslation();
  const { className, isMobile, disable, options, isDefault, onFilterChange, disableTooltip, selectedVal } = props;

  if (disable && disable.includes("class")) {
    return null;
  }

  const formatOptionLabel = ({ value, label, img }) => (
    <div className="class-option">
      {img ? (
        <img
          className="class-img"
          style={{ width: "25px", height: "25px", borderRadius: "50%", marginLeft: 1 }}
          src={img}
          alt={label}
        />
      ) : null}
      <span style={{ marginLeft: "10px" }}>{t(label)}</span>
    </div>
  );

  return (
    <TooltipContainer
      ref={tooltipRef}
      tooltipInfo={t("Change Class")}
      customClassName={className}
      disableTooltip={isMobile || disableTooltip}
    >
      <div>
        <DefaultSelect
          title={t("Change Class")}
          group={"class"}
          isMobile={isMobile}
          className={`filter-select filter-select_class ${isDefault}`}
          options={options}
          onChange={(selected) => {
            onFilterChange("class", selected.value, false, classTypeIdx);
          }}
          value={selectedVal}
          formatOptionLabel={formatOptionLabel}
          width={170}
          isSearchable={false}
          onMenuClose={() => tooltipRef.current.forceClose()}
        />
      </div>
    </TooltipContainer>
  );
};

export default Class;
